import axios from 'axios';
import Swal from 'sweetalert2';

const apiUrl = process.env.REACT_APP_API_URL;

let authToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null

const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    Authorization: authToken ? `Bearer ${authToken}` : undefined,
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (req) => {
    if (!authToken) {
      authToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null
      req.headers.Authorization = `Bearer ${authToken}`;
    }
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        const refreshResponse = await refreshTokenAndRetry(error);
        return refreshResponse;
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    } else {
      const result = {
        statusCode: error.response?.data?.statusCode || error.response?.status || 500,
        message: error.response?.data?.message || 'Unknown error',
      };
      if (error.response?.data?.statusList) {
        result.statusList = error.response.data.statusList;
      }
      return Promise.reject(result);
    }
  }
);

async function refreshTokenAndRetry(error) {
  try {
    const response = await refreshToken(error);
    return response;
  } catch (refreshError) {
    return Promise.reject(refreshError);
  }
}

async function refreshToken(error) {
  try {
    const response = await axios.post(`${apiUrl}api/v1/ekutir/user/auth/refreshToken`, { data: { "refreshToken": localStorage.getItem('refreshToken') } });
    if (response.data.statusCode === 200 || response.data.statusCode === 201) {
      const { accessToken, refreshToken } = response.data.data;
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      error.response.config.headers['Authorization'] = `Bearer ${response.data.data.accessToken}`;
      return axiosInstance.request(error.response.config);
    } else {
      if (response.data.statusCode === 401) {
        handleSessionExpired();
      }
    }
  } catch (err) {
    handleSessionExpired();
  }
}


function handleSessionExpired() {
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessToken");
  Swal.fire({
    text: 'Session Expired',
    confirmButtonText: 'Ok',
    customClass: {
      popup: 'customSwal',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = '/auth/login';
    }
  });
  throw new Error('Session expired');
}

export default axiosInstance;